import React from "react";
import { withStyles } from "@material-ui/styles";
import { observer } from "mobx-react";
import LocationWithUserPic from "../LocationWithUserPic";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import CloseIcon from "@material-ui/icons/Close";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import {
  adjustReport,
  markLocationAsDeleted,
  favoriteReportById,
} from "../../firestorter";
import authStore from "../../authStore";
import { CONSTANTS, titleByScore, colorByScore } from "../../utils";
import ReportButtons from "../ReportButtons";
import ReportPanel from "../ReportPanel";

const classes = {
  panel: {
    backgroundColor: "#b14d9b",
    color: "white",
    textAlign: "center",
    padding: "1rem",
  },
  closeBtn: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
  },
  favorite: {
    marginTop: "1rem",
  },
};

class ReportOption extends React.Component {
  titleByScore() {
    return titleByScore(+this.props.score);
  }
  colorByScore() {
    return colorByScore(+this.props.score);
  }
  render() {
    return (
      <div onClick={this.props.addReport}>
        <LocationOnIcon
          style={{
            color: this.colorByScore(),
            fontSize: "2rem",
            padding: "2rem",
            backgroundColor: "rgba(255,255,255,0.2)",
          }}
        ></LocationOnIcon>
        <div style={{ fontSize: "1.5rem" }}>{this.titleByScore()}</div>
      </div>
    );
  }
}

const LocationPanel = observer(
  class LocationPanel extends React.Component {
    constructor() {
      super();
      this.state = {
        lastReport: null,
        location: null,
      };
    }

    async componentWillMount() {
      const lastReport = this.props.params.location.lastReport;
      const location = Object.assign(
        { id: this.props.params.location_id },
        this.props.params.location
      );

      this.setState({
        lastReport: lastReport,
        location: location,
      });
    }

    isRecentAndOwnedReport() {
      const currentTimestamp = new Date().getTime() / 1000;
      const lastReport = this.state.lastReport;
      let isRecentAndOwned = false;

      if (
        lastReport &&
        lastReport.score === CONSTANTS.REPORT_SCORE.CLEAN &&
        lastReport.createdOn
      ) {
        const beforeSec = currentTimestamp - lastReport.createdOn.seconds;
        isRecentAndOwned = beforeSec < 6 * CONSTANTS.DURATION_IN_SEC.DAY;
      }

      return isRecentAndOwned;
    }

    deleteLocation() {
      const self = this;
      markLocationAsDeleted(this.props.params.location_id).then((res) => {
        self.setState({ action: null });
        self.props.closePanel();
      });
    }

    cancelDeletionProcess() {
      this.setState({ action: null });
    }

    startDeletionProcess() {
      this.setState({ action: "deletion_process" });
    }

    render() {
      const currentUser = authStore.user.get();
      const { classes } = this.props;
      const locationScore = this.props.params.location.currentScore;
      const lastReport = this.props.params.location.lastReport;
      const isRecentAndOwnedReport = this.isRecentAndOwnedReport();

      const panel = isRecentAndOwnedReport ? (
        <div>
          <div>
            <LocationWithUserPic
              photoURL={this.state.lastReport.user.photoURL}
            />
          </div>
          <div>{this.state.lastReport.displayName}</div>
          <div>{this.props.params.location.name}</div>
          {currentUser && lastReport.user.id !== currentUser.uid ? (
            <div
              className={classes.favorite}
              onClick={function () {
                favoriteReportById(lastReport.id);
              }}
            >
              {currentUser.hearted &&
              currentUser.hearted.indexOf(lastReport.id) !== -1 ? (
                <FavoriteIcon
                  htmlColor={CONSTANTS.COLOR.CLEAN}
                  style={{
                    fontSize: "3rem",
                    strokeWidth: "0.15rem",
                    stroke: "white",
                    verticalAlign: "-0.4rem",
                  }}
                />
              ) : (
                <FavoriteBorderIcon
                  style={{ fontSize: "3rem", verticalAlign: "-0.4rem" }}
                />
              )}
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          <LocationOnIcon
            style={{
              color: colorByScore(locationScore),
              fontSize: this.props.fontSize || "8rem",
            }}
          ></LocationOnIcon>
          <div style={{ marginBottom: "1rem", fontWeight: "bold" }}>
            {titleByScore(locationScore)}
          </div>
          
          <div>{this.props.params.location.score}</div>
          <div>{this.props.params.location.name}</div>
            
          <ReportPanel closePanel={this.props.closePanel} location={this.state.location}/>

        </div>
      );

      return (
        <div className={classes.panel}>
          <div className={classes.closeBtn} onClick={this.props.closePanel}>
            <CloseIcon fontSize="small" />
          </div>
          {panel}
          {currentUser && currentUser.admin ? (
            <div>
              {this.state.action === "deletion_process" ? (
                <div>
                  <a
                    href="#"
                    onClick={this.deleteLocation.bind(this)}
                    style={{ margin: "0.5rem" }}
                  >
                    אישור
                  </a>
                  <a
                    href="#"
                    onClick={this.cancelDeletionProcess.bind(this)}
                    style={{ margin: "0.5rem" }}
                  >
                    ביטול
                  </a>
                </div>
              ) : (
                <a href="#" onClick={this.startDeletionProcess.bind(this)}>
                  מחק מיקום
                </a>
              )}
            </div>
          ) : null}
        </div>
      );
    }
  }
);

export default withStyles(classes)(LocationPanel);
